import React from "react";
import "./ButtonCard.css";

interface Props {
  children: React.ReactNode;
  buttonKey: string;
  onSelect: (buttonKey: string) => void;
}

function ButtonCard(props: Props) {
  const { children } = props;

  const handleClick = () => {
    props.onSelect(props.buttonKey);
  };

  return (
    <div className="button-card-wrapper">
      <button className="button-card-btn" type="button" onClick={handleClick}>
        {children}
      </button>
    </div>
  );
}

export default ButtonCard;
